export const getPlayerSize = (
  wrapperWidth: number,
  wrapperHeight: number,
  ratio: number,
  playerRatio: number
): [number, number] => {
  if (playerRatio <= 0) {
    return [wrapperWidth, wrapperHeight];
  }

  let playerWidth = wrapperWidth;
  let playerHeight = wrapperHeight;

  if (ratio > 0 && ratio < playerRatio) {
    playerWidth = wrapperHeight / playerRatio;
  } else {
    playerHeight = playerRatio * wrapperWidth;
  }

  return [playerWidth, playerHeight];
};
